import React from 'react';
import { NavLink, useNavigate, Link } from 'react-router-dom';
import { useVolunteerAuth } from '../../hooks/useVolunteerAuth';
import { signOutVolunteer } from '../../services/volAuth';
import './VolNav.css';

function VolNav() {
  const { firebaseUser, volunteer } = useVolunteerAuth();
  const navigate = useNavigate();

  const isAdmin = localStorage.getItem('adminAuth') === 'true';
  const approved = isAdmin || volunteer?.approvalStatus === 'approved';

  const handleSignOut = async () => {
    await signOutVolunteer();
    navigate('/vol/login');
  };

  return (
    <nav className="vol-nav">
      <NavLink to="/vol/dashboard" className="vol-nav-brand">
        SMPW Masters
        <span>Volunteer Portal</span>
      </NavLink>

      {approved && (
        <div className="vol-nav-links">
          <NavLink to="/vol/dashboard" className={({ isActive }) => `vol-nav-link${isActive ? ' active' : ''}`}>
            My Shifts
          </NavLink>
          <NavLink to="/vol/profile" className={({ isActive }) => `vol-nav-link${isActive ? ' active' : ''}`}>
            My Profile
          </NavLink>
        </div>
      )}

      <div className="vol-nav-user">
        {isAdmin && (
          <>
            <span className="vol-nav-admin-badge">Admin</span>
            <Link to="/admin/dashboard" className="vol-nav-signout">← Admin Panel</Link>
          </>
        )}
        {!isAdmin && firebaseUser && (
          <>
            <span>{firebaseUser.displayName || firebaseUser.email}</span>
            <button className="vol-nav-signout" onClick={handleSignOut}>Sign out</button>
          </>
        )}
      </div>
    </nav>
  );
}

export default VolNav;
